<template>
  <popup :close-action="emitCloseEvent" class="apple-promotion-web-popup" :buttons="buttons">
    <template v-slot:title>
      <div class="ri-medium-bold-headline padding-top-sm">אפשר לממש את ההטבה רק דרך האפליקציה</div>
    </template>
    <template v-slot:content>
      <div class="ri-body padding-top-xs padding-bottom-ml">
        כיוון שהתשלום שלך לרייזאפ הוא דרך האפליקציה, כדי לממש את ההטבה צריך להיכנס לאפליקציה ממכשיר האייפון,
         ובעמוד ״הגדרות מינוי״ לבחור ״למימוש ההטבה״
      </div>
    </template>
  </popup>
</template>

<script>
import BenefitMixin from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitMixin.vue';
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'ApplePromotionWebPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  mixins: [
    BenefitMixin,
  ],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
  computed: {
    buttons() {
      return [{
        title: 'הבנתי',
        action: this.emitCloseEvent,
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.apple-promotion-web-popup {
  text-align: center;
  .popup {
    padding-bottom: 0;
  }
}
</style>
